interface Props {
  percentComplete: number;
}

const RADIUS = 10;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

function ProgressRing({ percentComplete }: Props) {
  const filled = (Math.min(Math.max(percentComplete, 0), 100) / 100) * CIRCUMFERENCE;

  return (
    <svg className="block" width="22" height="22" viewBox="0 0 26 26" aria-hidden="true">
      <circle cx="13" cy="13" r={RADIUS} fill="none" className="stroke-gray-300" strokeWidth="3" />
      <circle
        cx="13"
        cy="13"
        r={RADIUS}
        fill="none"
        stroke="var(--info-bg-success)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray={[filled, CIRCUMFERENCE].join(' ')}
        transform="rotate(-90 13 13)"
      />
    </svg>
  );
}

export default ProgressRing;
